module.exports = __webpack_public_path__ + "img/informasi-rdp-active.08f3b1dd.svg";